export default {
    title: 'Fiches Ideos',
    subtitle: "Recherchez une formation ou un métier du catalogue IDEO de l'ONISEP.",
    view: 'Voir',
    empty: 'Aucune fiche ne correspond à cette recherche.',
    loadError: "Les fiches Ideos n'ont pas pu être chargées.",
    refine: 'Plus de {count} fiches correspondent : affinez votre recherche.',
    tabs: {
        formations: 'Formations',
        metiers: 'Métiers',
    },
    search: {
        formations: 'Rechercher une formation par nom, ID Idéo 2 ou ID Idéo 1...',
        metiers: 'Rechercher un métier par nom, ID Idéo 2 ou ID Idéo 1...',
    },
    table: {
        idIdeo2: 'ID Idéo 2',
        idIdeo1: 'ID Idéo 1',
        name: 'Nom',
        actions: 'Actions',
    },
    detail: {
        idIdeo2: 'ID Idéo 2',
        idIdeo1: 'ID Idéo 1',
        accroche: 'Accroche',
        niveauEtude: "Niveau d'étude",
        statutExercice: "Statut d'exercice",
        domaines: 'Domaines',
        sousDomaines: 'Sous-domaines',
        centresInteret: "Centres d'intérêt",
        formations: 'Formations associées',
        notFound: "Cette fiche n'existe plus dans le catalogue IDEO.",
        loadError: "La fiche n'a pas pu être chargée.",
    },
}
